import React,{ useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import LandingPage from './components/LandingPage/LandingPage';
import {fetchContentFromAzureBlobStorage} from './data/Contentapi';

const Redirect = () => {
  const location = useLocation();
  
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const content = params.get('content');

    if(content === null || content === undefined) {
      return;
    }
    const parts = content.split('/');
    const category = parts[0];
    const contentType = parts[1];
    const contentVariable = parts[2];
    

    if (category) {
      const downloadPdf = async () => {
        try {
          const response = await fetchContentFromAzureBlobStorage(category, contentType, contentVariable);
          console.log('Response got');

          // Extract the Base64 string from the response
          const base64Data = response.imageString;

          // Decode the Base64 string to binary data
          const binaryString = atob(base64Data);
          const len = binaryString.length;
          const bytes = new Uint8Array(len);
          for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }

          // Create a Blob from the binary data
          const blob = new Blob([bytes], { type: 'application/pdf' });

          // Create a URL for the Blob and trigger the download
          const url = window.URL.createObjectURL(blob);
          

         // Navigate to the PDF in the same window
         window.location.href = url;

         // Optionally, you can revoke the object URL after navigation
         return () => {
           window.URL.revokeObjectURL(url);
         };
        } catch (error) {
          console.error('Error downloading the PDF:', error);
        }
      };

      downloadPdf();
    }
  }, [location]);

  return (
    <>
   {!new URLSearchParams(location.search).get('content') && <LandingPage />}
  </>
  );
};

export default Redirect;